export const toArray = (array: unknown) => (Array.isArray(array) ? array : []);

export function getArrayFromSize(size: number) {
  return Array.from(Array(size).keys());
}

export function deleteItemFromArray<T>(arr: T[] | undefined, predicate: (item: T) => boolean): T[] {
  if (!arr) {
    return [];
  }

  const itemIndex = arr.findIndex(predicate);

  if (itemIndex >= 0) {
    return [...arr.slice(0, itemIndex), ...arr.slice(itemIndex + 1)];
  }

  return arr;
}

export function addItemToUniqueArray<T>(
  arr: T[] | undefined,
  item: T,
  predicate: (existingItem: T, newItem: T) => boolean
): T[] {
  const newArr = new Array(...(arr ?? []));

  const itemExists = newArr.some(existingItem => predicate(existingItem, item));

  if (!itemExists) {
    newArr.push(item);
  }

  return newArr;
}
